export default {
  zh: {
    details: "查看详情",
    establish: "设立资料",
    company: "公司/基金管理公司名称:",
    license: "公司/基金管理公司注册号码:",
    constitution: "公司章程:",
    commercial: "营业执照(Biz/Gov File):",
    accessory: "其他附件:",
    basic: "基础信息",
    genericInvoice: "普通发票",
    amendsInvoice: "补款单发票",
    unpaid: "发票",
    refund: "退款发票",
    amends: "补款单",
    amount: "金额",
    remark: "说明",
    status: "状态",
    feeLetter: "收费协议",
    otherFee: "其他费用",
    thirdPartyFee: "第三方费用",
  },
  en: {
    details: "View details",
    establish: "Information",
    company: "Company/Fund Manager Name:",
    license: "Company/Fund Manager UEN:",
    constitution: "Constitution:",
    commercial: "Biz/Gov File:",
    accessory: "Other files:",
    basic: "Basic information",
    genericInvoice: "Generic Invoice",
    amendsInvoice: "Supplemental Invoice",
    unpaid: "Invoice",
    refund: "Debit Invoice",
    amends: "Supplemental",
    amount: "Amount",
    remark: "Description (For External Disclosure)",
    status: "Status",
    feeLetter: "Fee Letter",
    otherFee: "Other Fee",
    thirdPartyFee: "Third party fee",
  },
};
